import { useMemo, useState } from 'react'
import { Modal } from 'react-bootstrap'
import Iframe from 'react-iframe'
import { useDispatch } from 'react-redux'

import invoiceApi from 'api/invoiceApi'
import { setAppSpinning } from 'app/appSlice'
import DownloadXMLFileHelper from 'general/helpers/DownloadXMLFileHelper'
import Utils from 'general/utils/Utils'
import _ from 'lodash'
import ModalConvertPaper from '../ModalConvertPaper'
import './style.scss'

function ModalAccountingdocument(props) {
  const dispatch = useDispatch()
  const {
    invoiceUrl,
    lookupCode,
    invoice,
    showModalViewAD,
    setShowModalViewAD,
    accountingDocument,
  } = props

  const [showModalConvertPaper, setShowModalConvertPaper] = useState(false)

  const isTicket = useMemo(() => !!invoice?.ticketId, [invoice])

  const handleClose = () => setShowModalViewAD(false)

  const downloadFile = (bufferData, fileName, fileType) => {
    if (!bufferData) {
      console.error('Dữ liệu file không hợp lệ')
      return
    }
    // Chuyển đổi Buffer thành Uint8Array
    const fileData = new Uint8Array(bufferData)
    // Tạo Blob từ dữ liệu
    const blob = new Blob([fileData], { type: fileType })

    // Tạo URL object từ Blob
    const fileURL = URL.createObjectURL(blob)

    // Tạo thẻ <a> để tải file
    const link = document.createElement('a')
    link.href = fileURL
    link.download = fileName || 'document'

    // Thêm vào DOM và tự động click để tải file
    document.body.appendChild(link)
    link.click()

    // Xóa thẻ <a> sau khi tải xong
    document.body.removeChild(link)
    URL.revokeObjectURL(fileURL)
  }

  return (
    <>
      <Modal
        show={showModalViewAD}
        onHide={handleClose}
        centered
        className="ModalViewInvoice"
        style={{ zIndex: 1040 }}
      >
        <Modal.Header closeButton>
          <div className="w-100 d-flex flex-row justify-content-between">
            <Modal.Title>Thông tin chứng từ</Modal.Title>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex flex-row h-100">
            <Iframe
              url={invoiceUrl}
              width="1200px"
              height="100%"
              display="block"
              className="pl-4"
            />

            <div className="d-flex flex-column px-4" style={{ minWidth: 280 }}>
              <p className="mb-3 p-title">Thông tin chứng từ</p>

              <div className="d-flex flex-row justify-content-between border-bottom px-2 py-3">
                <span className="p-item">Số chứng từ:</span>
                <span className="p-item">
                  {accountingDocument?.resXML?.numberDocument}
                </span>
              </div>

              <div className="d-flex flex-row justify-content-between border-bottom px-2 py-3">
                <span className="p-item">Ký hiệu:</span>
                <span className="p-item">
                  {accountingDocument?.resXML?.serial}
                </span>
              </div>

              <div className="mt-10">
                <button
                  className="w-100 btn btn-outline-primary d-flex flex-row align-items-center mb-3"
                  onClick={() => {
                    //window.open(invoiceUrl, '_blank')
                    downloadFile(
                      accountingDocument?.resPdf?.data?.data,
                      accountingDocument?.resPdf?.fileName,
                      'application/pdf',
                    )
                  }}
                >
                  <i className="fa-solid fa-file-pdf"></i>
                  <span className="flex-fill">Tải chứng từ PDF</span>
                </button>

                <button
                  className="w-100 btn btn-outline-secondary d-flex flex-row align-items-center mb-3"
                  onClick={() => {
                    downloadFile(
                      accountingDocument?.resXML?.data?.data,
                      accountingDocument?.resXML?.fileName,
                      'application/xml',
                    )
                  }}
                >
                  <i className="fa-regular fa-download"></i>
                  <span className="flex-fill">Tải chứng từ XML</span>
                </button>

                <button
                  className="w-100 btn btn-outline-danger d-flex flex-row align-items-center mb-3"
                  onClick={() => {
                    var wnd = window.open(invoiceUrl)
                    wnd.print()
                  }}
                >
                  <i className="fa-regular fa-print"></i>
                  <span className="flex-fill">In chứng từ</span>
                </button>

                {/* <button className="w-100 btn btn-outline-warning d-flex flex-row align-items-center mb-3">
                  <i className="fa-regular fa-pen-nib"></i>
                  <span className="flex-fill">Ký chứng từ</span>
                </button> */}
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default ModalAccountingdocument
